import { categories, principles } from "@/mocks/melonData";
import { NAV, SITE_NAME } from "./brand";

export default function Footer() {
  return (
    <footer className="bg-background-200/60 text-foreground-800">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[minmax(0,1.3fr)_1fr_1fr_1fr]">
          {/* 品牌 */}
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-search-eye-line text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">
                {SITE_NAME}
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              做吃瓜界的把关人：以证据链说话，聚合爆料可信度、实锤过程与辟谣澄清，
              帮你把瓜看准、吃得明白。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-2-line", "ri-community-line"].map(
                (ic) => (
                  <a
                    key={ic}
                    href="#contact"
                    aria-label="关注我们"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors"
                  >
                    <i className={ic} />
                  </a>
                ),
              )}
            </div>
          </div>

          {/* 站内导航 */}
          <nav aria-label="站内导航">
            <h3 className="text-sm font-semibold text-foreground-950">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-sm text-foreground-700 hover:text-primary-700"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 覆盖栏目 */}
          <nav aria-label="覆盖栏目">
            <h3 className="text-sm font-semibold text-foreground-950">覆盖栏目</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(1).map((c) => (
                <li key={c}>
                  <a
                    href="#cases"
                    className="text-sm text-foreground-700 hover:text-primary-700"
                  >
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 内容原则 */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-950">内容原则</h3>
            <ul className="mt-4 space-y-2.5">
              {principles.map((p) => (
                <li key={p.title} className="text-sm text-foreground-700">
                  <span className="mr-1.5 text-primary-600">{p.title}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/60">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-4 py-5 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>
            © {new Date().getFullYear()} {SITE_NAME} · 吃瓜先求真，把瓜看准
          </p>
          <p>
            站内演示案例为虚构场景，仅用于说明核验机制，不对应任何真实人物或事件。
          </p>
        </div>
      </div>
    </footer>
  );
}